import { IconSearch } from "@tabler/icons-react";
import { useLanguage } from "../../context/LanguageContext";

type Props = {
  selectOptions?: any;
  name?: string;
  opt?: string;
  className?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};
export default function NormalSearch(props: Props) {
  const { t } = useLanguage();
  return (
    <div
      className={`border border-[#D8D8D8] bg-white flex items-center rounded-full px-4 py-1.5 gap-2 shadow-sm ${props.className} `}
    >
      <input
        className="text-sm placeholder:text-gray-400 focus:outline-none text-black font-medium placeholder:font-light w-full"
        placeholder={props.name ? t(props.name) : t("Search here...")}
        value={props?.value}
        onChange={props?.onChange}
      />
      <button className="text-gray-600 hover:text-black flex items-center flex-shrink-0">
        <IconSearch size={18} stroke={2} />
      </button>
    </div>
  );
}

